__turbopack_context__.v({
  "body": "ProfileModal-module-scss-module__UkiN7W__body",
  "content": "ProfileModal-module-scss-module__UkiN7W__content",
  "eyebrow": "ProfileModal-module-scss-module__UkiN7W__eyebrow",
  "eyebrowIcon": "ProfileModal-module-scss-module__UkiN7W__eyebrowIcon",
  "eyebrowText": "ProfileModal-module-scss-module__UkiN7W__eyebrowText",
  "header": "ProfileModal-module-scss-module__UkiN7W__header",
  "heading": "ProfileModal-module-scss-module__UkiN7W__heading",
  "title": "ProfileModal-module-scss-module__UkiN7W__title",
});
